import React from "react";
import { useTranslation } from "react-i18next";
import HeroSection from "../../components/common/HeroSection";
import PageShell from "../../components/common/PageShell";
import WelcomeSection from "../../components/common/WelcomeSection";
import ImageTextRow from "../../components/common/ImageTextRow";
import SectionHeader from "../../components/common/SectionHeader";
import ScrollReveal from "../../components/common/Reveal";
import QrcodeGrid from "../../components/qrcode/QrcodeGrid";
import { SERVICE_ROWS } from "../../constants/contentSections";
import { PAGE_HEROES } from "../../constants/pageHeroes";
import { INTRO_WIDTH } from "../../utils/layout";

function Services() {
  const { t } = useTranslation();

  return (
    <PageShell>
      <HeroSection {...PAGE_HEROES.services} variant="page" />
      <WelcomeSection introWidthClass={INTRO_WIDTH} compact>
        {SERVICE_ROWS.map((row) => (
          <ImageTextRow key={row.id} {...row} titleMode="plain" />
        ))}
        <ScrollReveal
          as="section"
          className="caf-section--elevated caf-section--elevated-tight mx-[-1rem] px-4 sm:mx-0 sm:rounded-2xl sm:px-6"
          aria-labelledby="services-qr-title"
        >
          <SectionHeader
            titleId="services-qr-title"
            eyebrow={t("Our Services")}
            title={t("Services")}
            subtitle={t(
              "Indulge in the Luxury of Tailored Style, Crafted Exclusively for You",
            )}
            className="!mb-5 sm:!mb-6"
          />
          <QrcodeGrid compact />
        </ScrollReveal>
      </WelcomeSection>
    </PageShell>
  );
}

export default Services;
